export default __webpack_public_path__ + "static/digital-onboarding_01-587f2e6a97806b8c7e8561c4b7861a1c.png";